import { BillingCardFields } from '@pages/BindQuote/BillingCard';

export const fieldValues: BillingCardFields = {
  street: { value: '', codeName: 'BillingStreet' },
  street2: { value: '', codeName: 'BillingStreet2' },
  city: { value: '', codeName: 'BillingCity' },
  state: { value: '', codeName: 'BillingState' },
  zip: { value: '', codeName: 'BillingZip' },
  emailAddress: { value: '', codeName: 'BillingEmail' },
  phone: { value: '', codeName: 'BillingPhone' },
  billPlan: { value: '', codeName: 'PaymentPlan' },
  primaryContact: {
    value: '',
    codeName: 'BillingContact',
  },
  endorsementPaymentOption: { value: '', codeName: 'EndorsementPaymentOption' },
  binderInd: { value: false, codeName: 'BinderInd' },
  bindingConditionsDetails: { value: '', codeName: 'BindingConditionsDetails' },
  billingMethod: { value: '', codeName: 'BillingMethod' },
};
